module.exports = __webpack_public_path__ + "static/media/inside-front.2c694e03.svg";